import PropTypes from 'prop-types';
import React from 'react';
import { IconInformationOutline } from '../Icons';

const DeletionNote = ({ deletionNoteText, deletionNoteUrl }) => (
  <div className="flex justify-center items-center text-slate-500 text-xs">
    <div className="flex flex-wrap">{deletionNoteText}</div>
    {deletionNoteUrl && (
      <a
        href={deletionNoteUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center text-blue-500 hover:text-blue-700 ml-2"
      >
        <IconInformationOutline size="4" className="fill-current" />
      </a>
    )}
  </div>
);

DeletionNote.defaultProps = {
  deletionNoteUrl: '',
};

DeletionNote.propTypes = {
  deletionNoteText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  deletionNoteUrl: PropTypes.string,
};

export default DeletionNote;
